// extracted by mini-css-extract-plugin
module.exports = {"loginHeader":"Login_loginHeader__2ybYh"};